import { Component, OnInit } from '@angular/core';
import {OrderService} from "../../../../services/OrderService";
import {Events} from "../../../../../framework/providers/events";
import {ModelToolsProvider} from "../../../../../framework/providers/model-tools/model-tools";

@Component({
  selector: 'app-cart-status',
  templateUrl: './cart-status.component.html',
  styleUrls: ['./cart-status.component.scss'],
})
export class CartStatusComponent implements OnInit {

  public cartStatus;
  public prefix = 'CartStatusComponent_'+this.tools.getRandomize();

  constructor(public orderService:OrderService, public events:Events, public tools:ModelToolsProvider) { }

  ngOnInit() {
    this.getCartStatus();

    this.events.subscribe('cartStatusChanged', (params) => {
      this.getCartStatus();
    }, this.prefix);
  }

  ngOnDestroy()
  {
    this.events.unsubscribe('cartStatusChanged', this.prefix);
  }

  getCartStatus() {
    this.cartStatus = this.orderService.getCartStatus();
  }

  refresh()
  {
    this.orderService.checkUserUpdates();
  }

}
